import React from 'react';
import { Tooltip } from '@shared/UI';
import './TextTooltip.scss';

interface IChangedValueItemProps {
    text: string;
    maxLength?: number;
}

export const TextTooltip: React.FC<IChangedValueItemProps> = ({ text, maxLength = 7 }) => {
    const truncatedText = text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

    return (
        <span data-tooltip-id={text}>
            {truncatedText}
            <Tooltip
                id={text}
                place={'bottom'}
                content={text}
                opacity={1}
                style={{
                    backgroundColor: '#FFFFFF',
                    padding: 12,
                    borderRadius: 12,
                    fontSize: 12,
                    color: '#000000BF',
                    boxShadow: '0px 0px 6px -1px #0000001A',
                    maxWidth: '500px',
                }}
            />
        </span>
    );
};
